module.exports = __webpack_public_path__ + "static/onizleme-94577bbdc3a970ea0882a8ea161fad90.png";